import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { loginUser } from '../utils/api';
import { useLogo } from '../hooks/useLogo';

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const logo = useLogo();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    try {
      const data = await loginUser(email, password);
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('email', data.email);
      localStorage.setItem('token', data.token);
      localStorage.setItem('groupIdList', JSON.stringify(data.groupIdList));
      localStorage.setItem('level', data.level);
      localStorage.setItem('createdAt', data.createdAt);
      localStorage.setItem('expiresAt', data.expiresAt);

      onLogin(true);
      const from = location.state?.from?.pathname || '/welcome';
      navigate(from, { replace: true });
    } catch (err) {
      console.error(err);
      setError(err.message || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen bg-dark flex flex-col items-center justify-center px-4">
      {/* Logo */}
      <div className="mb-8 flex justify-center">
        <img src={logo} alt="Logo" className="h-12 max-w-[200px] object-contain mx-auto" />
      </div>

      {/* Login form */}
      <div className="w-full max-w-sm space-y-4">
        <input
          type="email"
          placeholder="Email"
          className="input bg-[#1a1f2b] text-white placeholder-gray-400"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="input bg-[#1a1f2b] text-white placeholder-gray-400"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <button
          className="w-full py-3 rounded-md bg-primary text-white font-semibold hover:bg-primary/80 transition"
          onClick={handleLogin}
        >
          Log In
        </button>
      </div>
    </div>
  );
}
